if (!customElements.get('product-card-info')) {
  customElements.define(
    'product-card-info',
    class ProductCardInfo extends HTMLElement {
      constructor() {
        super();
        this.sectionId = this.dataset.sectionId;
        this.productFormId = this.dataset.productFormId;
        this.productForm = document.getElementById(this.productFormId);
        this.productId = this.dataset.productId;
        this.section = document.getElementById(`shopify-section-${this.sectionId}`);
        this.variantPicker = document.getElementById(`variant-picker--${this.productFormId}`);

        if (this.variantPicker) {
          this.variantPicker.querySelectorAll('input[type="radio"], option').forEach((selector) => {
            selector.addEventListener('click', this.onVariantChange.bind(this));
          });
        }
      }

      onVariantChange(event) {
        const productUrl = event.target.dataset.productUrl || this.pendingRequestUrl || this.dataset.url;
        this.pendingRequestUrl = productUrl;
        const isCombinedListingProduct = this.dataset.url !== productUrl;

        // Don't handle combined listing products right now, they need custom coding
        if (isCombinedListingProduct) return;

        this.updateOptions();
        this.updateMasterId();
        this.toggleAddButton(true, '', false);
        this.updateSwatches(event);
        this.updateVariantStatuses();
        this.updateLinksInProductCard();
        this.removeErrorMessage();

        if (!this.currentVariant) {
          this.toggleAddButton(true, '', true);
          this.setUnavailable();
        } else {
          this.renderProductInfo();
          this.updateVariantInput();
        }
      }

      toCurrency(value) {
        return (parseFloat(value) * 0.01).toFixed(2);
      }

      updateHtml(source, destination) {
        if (source && destination) destination.innerHTML = source.innerHTML;
      }

      updateOptions() {
        let selectedValues = [];

        this.variantPicker.querySelectorAll('fieldset').forEach((selector) => {
          if (selector.querySelector('select')) {
            selectedValues.push(selector.querySelector('select').value);
          } else {
            selectedValues.push(selector.querySelector('input[type="radio"]:checked').value);
          }
        });

        this.options = selectedValues;
      }

      updateMasterId() {
        this.currentVariant = this.getVariantData().find((variant) => {
          return !variant.options.map((option, index) => {
            return this.options[index] === option;
          }).includes(false);
        });
      }

      updateMasterIdWithVariantId(variantId) {
        this.currentVariant = this.getVariantData().find((variant) => {
          if (variant.id === parseInt(variantId)) {
            return variant;
          }
        });
      }

      updateSwatches(event) {
        const currentSwatchOption = event.target.parentNode.closest('fieldset[data-swatch-option]');
        if (!currentSwatchOption) return;

        const currentSwatchOptionPosition = currentSwatchOption.dataset.optionPosition;
        const allSwatchOptions = this.variantPicker.querySelectorAll(`[data-swatch-option="${this.productFormId}"]`);

        allSwatchOptions.forEach((option) => {
          if (option.dataset.optionPosition === currentSwatchOptionPosition) {
            // Update swatch name
            option.querySelector("[data-swatch-name]").innerHTML = currentSwatchOption.querySelector('input:checked').value;

            // Update checked swatch on other variant selects for this product in this section
            const allOptionSwatchInputs = Array.from(option.querySelectorAll('input[type="radio"]'));

            const selectedSwatch = allOptionSwatchInputs.find(input => input.value === currentSwatchOption.querySelector('input:checked').value);

            selectedSwatch.checked = true;
          }
        });
      }

      updateLinksInProductCard() {
        let url = new URL(`${this.dataset.shopUrl}${this.dataset.url}`);
        let params = new URLSearchParams(url.search);
        params.set('variant', this.currentVariant.id);
        url.search = params.toString();

        this.querySelectorAll('[data-product-link]').forEach((link) => {
          link.setAttribute('href', url.href);
        });
      }

      updateVariantStatuses() {
        const fieldsets = [...this.variantPicker.querySelectorAll('fieldset')];
        const selectedOptionOneVariants = this.variantData.filter(
          (variant) => this.querySelector(':checked').value === variant.option1
        );

        fieldsets.forEach((option, index) => {
          if (index === 0) return;
          const optionInputs = [...option.querySelectorAll('input[type="radio"], option')];
          const previousOptionSelected = fieldsets[index - 1].querySelector(':checked').value;
          const availableOptionInputsValue = selectedOptionOneVariants
            .filter((variant) => variant.available && variant[`option${index}`] === previousOptionSelected)
            .map((variantOption) => variantOption[`option${index + 1}`]);
          this.setInputAvailability(optionInputs, availableOptionInputsValue);
        });
      }

      setInputAvailability(listOfOptions, listOfAvailableOptions) {
        listOfOptions.forEach((input) => {
          if (input.type === 'radio') {
            if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
              input.closest('label').classList.remove('unavailable');
              } else {
              input.closest('label').classList.add('unavailable');
            }
          } else {
            if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
              input.innerText = input.getAttribute('value');
            } else {
              input.innerText = window.variantStrings.unavailable_with_option.replace('[value]', input.getAttribute('value'));
            }
          }
        });
      }

      detectVariantsForSelectedOption(fieldsets, optionPosition) {
        fieldsets.forEach((fieldset) => {
          if (fieldset.querySelector('select')) {
            return this.variantData.filter(variant => fieldset.querySelector('select').value === variant[optionPosition]);
          } else {
            return this.variantData.filter(variant => fieldset.querySelector('input:checked').value === variant[optionPosition]);
          }
        });
      }

      // Updates the input values so the correct variant is added to the cart
      updateVariantInput() {
        const input = this.productForm.querySelector('input[name="id"]');
        input.value = this.currentVariant.id;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }

      removeErrorMessage() {
        if (!this.section) return;
        const productFormElement = this.querySelector('product-form');
        if (productFormElement) productFormElement.handleErrorMessage();
      }

      // Get the info for the current variant and render it on the card
      renderProductInfo() {
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);

        fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.sectionId}`)
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            const sectionId = this.sectionId;

            publish(PUB_SUB_EVENTS.variantChange, {
              data: {
                sectionId,
                html,
                variant: this.currentVariant,
              },
            });
          });
      }

      // Update product forms based on variant change, and disable if variant is sold out or unavailable
      toggleAddButton(disable = true, text, modifyClass = true) {
        const addButton = this.productForm.querySelector('[data-submit-button]');
        const addButtonText = this.productForm.querySelector('[data-submit-button-text]');
        const buttonPrice = this.productForm.querySelector('[data-button-price]');
        const buttonPriceContainer = this.productForm.querySelector('[data-button-price-container]');
        const quantityActionElements = this.productForm.querySelectorAll('[data-quantity-action-element]');

        if (disable) {
          addButton.setAttribute('disabled', 'disabled');
          if (text) addButtonText.textContent = text;
          if (quantityActionElements) quantityActionElements.forEach((element) => element.setAttribute('disabled', true));

          if (this.currentVariant) {
            if (buttonPriceContainer) buttonPriceContainer.classList.remove('display--none');
            if (buttonPrice) buttonPrice.textContent = this.toCurrency(this.currentVariant.price);
          } else {
            if (buttonPriceContainer) buttonPriceContainer.classList.add('display--none');
          }
        } else {
          addButton.removeAttribute('disabled');
          addButtonText.textContent = window.variantStrings.addToCart;
          if (buttonPriceContainer) buttonPriceContainer.classList.remove('display--none');
          if (buttonPrice) buttonPrice.textContent = this.toCurrency(this.currentVariant.price);
        }
      }

      // Indicates if the variant selected is unavailable
      setUnavailable() {
        const addButton = this.productForm.querySelector('[data-submit-button]');
        const addButtonText = this.productForm.querySelector('[data-submit-button-text]');
        const buttonPriceContainer = this.productForm.querySelector('[data-button-price-container]');

        if (buttonPriceContainer) buttonPriceContainer.classList.add('display--none');
        if (addButton) addButtonText.textContent = window.variantStrings.unavailable;
      }

      getVariantData() {
        this.variantData = this.variantData || JSON.parse(this.querySelector('variant-selects [data-product-variants]').textContent);
        return this.variantData;
      }
    }
  );
}
